import { Component } from '@angular/core';

@Component({
    selector: 'app-closed-wallet',
    templateUrl: './closed-wallet.component.html',
    styleUrls: ['./closed-wallet.component.scss'],
    standalone: false
})
export class ClosedWalletComponent {}